import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { MediaViewDialogData } from '@fc-shared/ui/media-view-dialog/models/media-view-dialog-data.model';
import { MediaViewerDialogComponent } from './components/media-viewer.dialog';

@Injectable({
  providedIn: 'root',
})
export class MediaViewService {
  private matDialog: MatDialog = inject(MatDialog);

  openMediaViewDialog(
    data: MediaViewDialogData,
  ): MatDialogRef<MediaViewerDialogComponent> {
    return this.matDialog.open(MediaViewerDialogComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      panelClass: 'media-view-dialog',
      backdropClass: 'media-view-backdrop',
      autoFocus: 'dialog',
      data: data,
    });
  }
}

export function isMediaFile(file: AttachmentModel): boolean {
  if (!file) return false;
  if (!file?.mimeType) return false;

  const mimeType = file.mimeType.toLowerCase();
  return (
    mimeType.startsWith('image/') ||
    mimeType.startsWith('video/') ||
    mimeType.startsWith('audio/') ||
    mimeType === 'application/pdf'
  );
}

/** Fallback `src` for browsers ignoring `srcset`, and the preload target. */
export function getImagePreview(media: AttachmentModel): string | undefined {
  return media?.thumbnails?.xxl?.url || media?.previewImg;
}

export const MEDIA_VIEWER_UNZOOMED_SIZES = '100vw';

// TODO: do we event need other type? [todo-029]
export type FileType = 'video' | 'image' | 'pdf' | 'other';

export function getFileType(mimeType: string | undefined): FileType {
  if (!mimeType) return 'other';
  if (mimeType.startsWith('video/')) return 'video';
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType === 'application/pdf') return 'pdf';
  return 'other';
}
